import { render, staticRenderFns } from "./SettingsActivity.vue?vue&type=template&id=5cb00ba3&scoped=true"
import script from "./SettingsActivity.vue?vue&type=script&lang=js"
export * from "./SettingsActivity.vue?vue&type=script&lang=js"
import style0 from "./SettingsActivity.vue?vue&type=style&index=0&id=5cb00ba3&prod&lang=scss&scoped=true"
import style1 from "./SettingsActivity.vue?vue&type=style&index=1&id=5cb00ba3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb00ba3",
  null
  
)

export default component.exports